export default "__VITE_ASSET__BaNELNGF__"